export default __webpack_public_path__ + "static/media/project3.48d67d2c.PNG";